(function () {
    'use strict';

    angular
        .module('app.tasks')
        .factory('linkedTask.dialog', linkedTaskDialog);

    linkedTaskDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];
    /* @ngInject */
    function linkedTaskDialog($modal, $templateCache, opsIncludeVersion) {
        var service = {
            display: display
        }

        $templateCache.put('linkedTaskDialog.tpl.html?v=' + opsIncludeVersion,
             '<div >' +
             '    <div class="modal-header">' +
             '        <button type="button" class="close" data-dismiss="modal" ' +
             '            aria-hidden="true" data-ng-click="vm.cancel()">&times;</button>' +
             '        <h3>New Linked Task</h3>' +
             '    </div>' +
             '    <div class="modal-body" ng-include="\'app/tasks/_details.html?v=' + opsIncludeVersion +'\'">' +
             '    </div>' +
             '    <div class="modal-footer">' +
                '        <button class="btn btn-primary" data-ng-click="vm.save()" data-ng-disabled="theForm.$invalid"><i class="fa fa-save"></i>{{vm.okText}}</button>' +
                '        <button class="btn btn-warning" data-ng-click="vm.cancel()"><i class="fa fa-undo"></i>{{vm.cancelText}}</button>' +
                '    </div>' +
             '</div>');

        return service;

        function display(item, settings) {
            var modalOptions = {
                templateUrl: 'linkedTaskDialog.tpl.html?v=' + opsIncludeVersion,
                controller: LinkedTaskModalInstance,
                controllerAs: "vm",
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            item: item,
                            settings: settings
                        };
                    }
                }
            };

            return $modal.open(modalOptions).result;
        }
    }


    LinkedTaskModalInstance.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice', '$window'];

    /* @ngInject */
    function LinkedTaskModalInstance($modalInstance, options, common, dataservice, $window) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        vm.okText = 'Save';
        vm.cancelText = 'Cancel';
        vm.item = undefined;
        vm.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        vm.isSaving = false;
        vm.save = save;
        vm.openDatePicker = openDatePicker;
        vm.usersInDepartments = [];
        vm.allUsers = [];
        vm.templates = [];
        vm.dpStatus = {
            displayOnOpen: false,
        }
        vm.datePickerOptions = {
            showWeeks: false,
            ngModelOptions: {
                allowInvalid: false
            }
        };
        vm.departments = [];
        vm.departmentChange = departmentChange;
        vm.templateChange = templateChange;
        vm.selectedTemplate = null;


        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                departmentChange();
            }, function (error) { });

        }

        function openDatePicker($event) {
            vm.dpStatus.displayOnOpen = true;
        }

        function templateChange() {
            if (vm.selectedTemplate) {
                for (var i = 0; i < vm.templates.length; i++) {
                    var t = vm.templates[i];
                    if (vm.selectedTemplate === t.UId) {
                        if (vm.item.Description) {
                            vm.item.Description += "\n" + t.Description;
                        }
                        else {
                            vm.item.Description = t.Description;
                        }

                        vm.item.DepartmentIds = t.DepartmentIds;
                        vm.item.StartAtDisplay = moment(t.StartAtDisplay.substr(0, 16)).toDate();
                        if (t.FinishByDisplay !== null) {
                            vm.item.IncludeFinishBy = 1;
                            vm.item.FinishByDisplay = moment(t.FinishByDisplay.substr(0, 16)).toDate();
                        }

                        break;
                    }
                }
            }
        }

        function getItem() {
            
            return dataservice.getItem("api/Tasks/0")
                .then(function (response) {
                    if (response) {
                        vm.departments = response.data.departments;
                        vm.allUsers = response.data.usersWithDepartments;
                        vm.templates = response.data.taskTemplates;
                        vm.item = {};
                        vm.item.Description = "Set " + options.item.RoomDescription + " for " + options.item.EventName + " on " + moment(options.item.BuildingLocalEventStart).format("L"),
                            vm.item.StartAtDisplay = moment().set("hour", 6).set("minute", 0).toDate();
                        vm.item.IncludeFinishBy = 0;
                        vm.item.EmailUserTheyHaveANewTask = 0;
                        vm.item.LinkedBookingId = options.item.BookingId;
                        var displayOn = new Date();
                        if (options.settings) {
                            for (var i = 0; i < options.settings.length; i++) {
                                if (options.settings[i].SettingKey == "UseBookingDateForLinkedTask") {
                                    if (options.settings[i].SettingValue == "1") {
                                        displayOn = new Date(options.item.BuildingLocalEventStart);
                                    }
                                }
                            }
                        }

                            vm.item.DisplayOn = displayOn
                            try {
                                var deptIdsAsString = $window.localStorage.getItem("SevenPointTaskDepartmentIds");
                                vm.item.DepartmentIds = [];
                                if (deptIdsAsString) {
                                    try {
                                        var deptIds = deptIdsAsString.split(',');
                                        for (var i = 0; i < deptIds.length; i++) {
                                            for (var j = 0; j < vm.departments.length; j++) {
                                                if (vm.departments[j].ID == deptIds[i]) {
                                                    vm.item.DepartmentIds.push(deptIds[i])
                                                }
                                            }

                                        }

                                    }
                                    catch (error) {
                                        console.log(error);
                                        vm.item.DepartmentIds = [];
                                        vm.item.DepartmentIds.push(0);
                                    }
                                }
                                else {
                                    vm.item.DepartmentIds = [];
                                    vm.item.DepartmentIds.push(0);
                                }
                            }
                            catch (error) {
                                console.log(error);
                                vm.item.DepartmentIds = [];
                                vm.item.DepartmentIds.push(0);
                            }

                            vm.item.StartAtDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 6, 0, 0, 0)
                            vm.item.FinishByDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 17, 0, 0, 0);
                            vm.item.AssignedToUserId = 0;
                            vm.item.EmailUserTheyHaveANewTask = 0
                            common.setAuditInfo(vm.item);

                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                });
        }

        function departmentChange() {
            vm.usersInDepartments = [];
            var addedUserIds = [];
            for (var i = 0; i < vm.allUsers.length; i++) {
                var user = vm.allUsers[i];
                for (var j = 0; j < user.Departments.length; j++) {
                    for (var ii = 0; ii < vm.item.DepartmentIds.length; ii++) {
                        if (vm.item.DepartmentIds[ii] == user.Departments[j]) {
                            if (addedUserIds.indexOf(user.Id) === -1) {
                                addedUserIds.push(user.Id);
                                vm.usersInDepartments.push(user);
                            }
                        }
                    }
                }
            }
        }

        function save() {
            if (vm.item.DepartmentIds.length === 0) {
                common.logger.error("You must select at least one department");
                return;
            }

            var fromLocal = common.buildDateTime(vm.item.DisplayOn, vm.item.StartAtDisplay);

            if (vm.item.DisplayUntil) {
                var displayFrom = moment(fromLocal);
                var displayUntil = moment(vm.item.DisplayUntil);

                if (displayFrom.isAfter(displayUntil)) {
                    common.logger.error("Display Until must be after Display On");
                    return;
                }


                if (!vm.item.DisplaysOnSunday
                    && !vm.item.DisplaysOnMonday
                    && !vm.item.DisplaysOnTuesday
                    && !vm.item.DisplaysOnWednesday
                    && !vm.item.DisplaysOnThursday
                    && !vm.item.DisplaysOnFriday
                    && !vm.item.DisplaysOnSaturday
                ) {
                    common.logger.error("Repeating tasks must repeat on a least one day of the week");
                    return;
                }

            }


            if (vm.item.IncludeFinishBy == 1) {

                var toLocal = common.buildDateTime(vm.item.DisplayOn, vm.item.FinishByDisplay);
                if (toLocal < fromLocal) {
                    logger.error("Finish By must be after Start At")
                    return;
                }
                vm.item.FinishBy = moment(toLocal).format("HH:mm");
            }
            else {
                vm.item.FinishBy = null;
            }

            vm.item.DisplayOn = moment(fromLocal).format("YYYY-MM-DDT00:00");

            vm.item.StartAt = moment(fromLocal).format("HH:mm");
            vm.isSaving = true;
            $window.localStorage.setItem("SevenPointTaskDepartmentIds", vm.item.DepartmentIds.join());
            dataservice.saveItem('api/Tasks', vm.item).then(function (saveResult) {

                vm.isSaving = false;
                common.notifier.notify(common.config.events.taskCountChange);
                $modalInstance.close(saveResult);
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }

        

        
    }
})();
